export default "__VITE_ASSET__77f4a931__"